// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Apply = require("../Control.Apply/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_Writer = require("../Control.Monad.Writer/index.js");
var Control_Monad_Writer_Class = require("../Control.Monad.Writer.Class/index.js");
var Control_Monad_Writer_Trans = require("../Control.Monad.Writer.Trans/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_HeytingAlgebra = require("../Data.HeytingAlgebra/index.js");
var Data_Identity = require("../Data.Identity/index.js");
var Data_List = require("../Data.List/index.js");
var Data_List_Types = require("../Data.List.Types/index.js");
var Data_Map = require("../Data.Map/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_String_Common = require("../Data.String.Common/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Lunarbox_Data_Dataflow_Runtime = require("../Lunarbox.Data.Dataflow.Runtime/index.js");
var Lunarbox_Data_Dataflow_Scheme = require("../Lunarbox.Data.Dataflow.Scheme/index.js");
var Lunarbox_Data_String = require("../Lunarbox.Data.String/index.js");
var VarName = function (x) {
    return x;
};
var NativeExpression = (function () {
    function NativeExpression(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    NativeExpression.create = function (value0) {
        return function (value1) {
            return new NativeExpression(value0, value1);
        };
    };
    return NativeExpression;
})();
var Variable = (function () {
    function Variable(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Variable.create = function (value0) {
        return function (value1) {
            return new Variable(value0, value1);
        };
    };
    return Variable;
})();
var FunctionCall = (function () {
    function FunctionCall(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    };
    FunctionCall.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return new FunctionCall(value0, value1, value2);
            };
        };
    };
    return FunctionCall;
})();
var Lambda = (function () {
    function Lambda(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    };
    Lambda.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return new Lambda(value0, value1, value2);
            };
        };
    };
    return Lambda;
})();
var Let = (function () {
    function Let(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    };
    Let.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return function (value3) {
                    return new Let(value0, value1, value2, value3);
                };
            };
        };
    };
    return Let;
})();
var If = (function () {
    function If(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    };
    If.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return function (value3) {
                    return new If(value0, value1, value2, value3);
                };
            };
        };
    };
    return If;
})();
var FixPoint = (function () {
    function FixPoint(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    };
    FixPoint.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return new FixPoint(value0, value1, value2);
            };
        };
    };
    return FixPoint;
})();
var Expression = (function () {
    function Expression(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Expression.create = function (value0) {
        return function (value1) {
            return new Expression(value0, value1);
        };
    };
    return Expression;
})();
var Native = (function () {
    function Native(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Native.create = function (value0) {
        return function (value1) {
            return new Native(value0, value1);
        };
    };
    return Native;
})();
var TypedHole = (function () {
    function TypedHole(value0) {
        this.value0 = value0;
    };
    TypedHole.create = function (value0) {
        return new TypedHole(value0);
    };
    return TypedHole;
})();
var unfoldLambda = function (v) {
    if (v instanceof Lambda) {
        var v1 = unfoldLambda(v.value2);
        return new Data_Tuple.Tuple(new Data_List_Types.Cons(v.value1, v1.value0), v1.value1);
    };
    return new Data_Tuple.Tuple(Data_List_Types.Nil.value, v);
};
var unfoldLambda$prime = function ($copy_v) {
    var $tco_done = false;
    var $tco_result;
    function $tco_loop(v) {
        if (v instanceof FixPoint) {
            $copy_v = new Lambda(v.value0, v.value1, v.value2);
            return;
        };
        if (v instanceof Lambda) {
            var v1 = unfoldLambda(v.value2);
            $tco_done = true;
            return new Data_Tuple.Tuple(new Data_List_Types.Cons(v.value1, v1.value0), v1.value1);
        };
        $tco_done = true;
        return new Data_Tuple.Tuple(Data_List_Types.Nil.value, v);
    };
    while (!$tco_done) {
        $tco_result = $tco_loop($copy_v);
    };
    return $tco_result;
};
var showNativeExpression = new Data_Show.Show(function (v) {
    return Data_Show.show(Lunarbox_Data_Dataflow_Runtime.showRuntimeValue)(v.value1) + (" :: " + Data_Show.show(Lunarbox_Data_Dataflow_Scheme.showScheme)(v.value0));
});
var newtypeVarName = new Data_Newtype.Newtype(function (n) {
    return n;
}, VarName);
var printRawLet = function (v) {
    return function (v1) {
        if (v1 instanceof Let) {
            return Lunarbox_Data_String.indent(2)(Data_Newtype.unwrap(newtypeVarName)(v1.value1) + (" = " + v(v1.value2))) + "\x0a";
        };
        return "";
    };
};
var printLet = function (v) {
    return function (v1) {
        return function (v2) {
            if (v && v2 instanceof Let) {
                return "let\x0a" + printLet(false)(v1)(v2);
            };
            if (!v && (v2 instanceof Let && v2.value3 instanceof Let)) {
                return printRawLet(v1)(v2) + printLet(false)(v1)(v2.value3);
            };
            if (!v && v2 instanceof Let) {
                return printRawLet(v1)(v2) + ("in\x0a" + Lunarbox_Data_String.indent(2)(v1(v2.value3)));
            };
            return "";
        };
    };
};
var showVarName = new Data_Show.Show(Data_Newtype.unwrap(newtypeVarName));
var isFunctionCall = function (v) {
    if (v instanceof FunctionCall) {
        return true;
    };
    return false;
};
var inputs = function ($374) {
    return Data_List.length(Data_Tuple.fst(unfoldLambda($374)));
};
var getLocation = function (v) {
    if (v instanceof Variable) {
        return v.value0;
    };
    if (v instanceof FunctionCall) {
        return v.value0;
    };
    if (v instanceof Lambda) {
        return v.value0;
    };
    if (v instanceof TypedHole) {
        return v.value0;
    };
    if (v instanceof Let) {
        return v.value0;
    };
    if (v instanceof FixPoint) {
        return v.value0;
    };
    if (v instanceof Native) {
        return v.value0;
    };
    if (v instanceof Expression) {
        return v.value0;
    };
    if (v instanceof If) {
        return v.value0;
    };
    throw new Error("Failed pattern match at Lunarbox.Data.Dataflow.Expression (line 134, column 15 - line 143, column 18): " + [ v.constructor.name ]);
};
var toMap = function (dictOrd) {
    return function (expression) {
        return Data_Semigroup.append(Data_Map_Internal.semigroupMap(dictOrd))(Data_Map_Internal.singleton(getLocation(expression))(expression))((function () {
            if (expression instanceof FunctionCall) {
                return Data_Semigroup.append(Data_Map_Internal.semigroupMap(dictOrd))(toMap(dictOrd)(expression.value1))(toMap(dictOrd)(expression.value2));
            };
            if (expression instanceof Lambda) {
                return toMap(dictOrd)(expression.value2);
            };
            if (expression instanceof Let) {
                return Data_Semigroup.append(Data_Map_Internal.semigroupMap(dictOrd))(toMap(dictOrd)(expression.value2))(toMap(dictOrd)(expression.value3));
            };
            if (expression instanceof Expression) {
                return toMap(dictOrd)(expression.value1);
            };
            if (expression instanceof FixPoint) {
                return toMap(dictOrd)(expression.value2);
            };
            if (expression instanceof If) {
                return Data_Semigroup.append(Data_Map_Internal.semigroupMap(dictOrd))(toMap(dictOrd)(expression.value1))(Data_Semigroup.append(Data_Map_Internal.semigroupMap(dictOrd))(toMap(dictOrd)(expression.value2))(toMap(dictOrd)(expression.value3)));
            };
            return Data_Monoid.mempty(Data_Map_Internal.monoidMap(dictOrd));
        })());
    };
};
var locations = function (dictOrd) {
    var $375 = toMap(dictOrd);
    return function ($376) {
        return Data_Map.keys($375($376));
    };
};
var lookup = function (dictOrd) {
    return function (key) {
        var $377 = Data_Map_Internal.lookup(dictOrd)(key);
        var $378 = toMap(dictOrd);
        return function ($379) {
            return $377($378($379));
        };
    };
};
var functorExpression = new Data_Functor.Functor(function (f) {
    return function (m) {
        if (m instanceof Variable) {
            return new Variable(f(m.value0), m.value1);
        };
        if (m instanceof FunctionCall) {
            return new FunctionCall(f(m.value0), Data_Functor.map(functorExpression)(f)(m.value1), Data_Functor.map(functorExpression)(f)(m.value2));
        };
        if (m instanceof Lambda) {
            return new Lambda(f(m.value0), m.value1, Data_Functor.map(functorExpression)(f)(m.value2));
        };
        if (m instanceof Let) {
            return new Let(f(m.value0), m.value1, Data_Functor.map(functorExpression)(f)(m.value2), Data_Functor.map(functorExpression)(f)(m.value3));
        };
        if (m instanceof If) {
            return new If(f(m.value0), Data_Functor.map(functorExpression)(f)(m.value1), Data_Functor.map(functorExpression)(f)(m.value2), Data_Functor.map(functorExpression)(f)(m.value3));
        };
        if (m instanceof FixPoint) {
            return new FixPoint(f(m.value0), m.value1, Data_Functor.map(functorExpression)(f)(m.value2));
        };
        if (m instanceof Expression) {
            return new Expression(f(m.value0), Data_Functor.map(functorExpression)(f)(m.value1));
        };
        if (m instanceof Native) {
            return new Native(f(m.value0), m.value1);
        };
        if (m instanceof TypedHole) {
            return new TypedHole(f(m.value0));
        };
        throw new Error("Failed pattern match at Lunarbox.Data.Dataflow.Expression (line 75, column 1 - line 75, column 56): " + [ m.constructor.name ]);
    };
});
var functionDeclaration = (function () {
    var $380 = Data_Foldable.foldr(Data_List_Types.foldableList);
    return function ($381) {
        return $380(Lambda.create($381));
    };
})();
var everywhereOnExpressionM = function (dictMonad) {
    return function (filter) {
        return function (f) {
            var go = function (v) {
                return function (v1) {
                    if (v1 instanceof FunctionCall) {
                        return Control_Apply.apply((dictMonad.Bind1()).Apply0())(Data_Functor.map(((dictMonad.Bind1()).Apply0()).Functor0())(FunctionCall.create(v1.value0))(v(v1.value1)))(v(v1.value2));
                    };
                    if (v1 instanceof Lambda) {
                        return Data_Functor.map(((dictMonad.Bind1()).Apply0()).Functor0())(Lambda.create(v1.value0)(v1.value1))(v(v1.value2));
                    };
                    if (v1 instanceof Let) {
                        return Control_Apply.apply((dictMonad.Bind1()).Apply0())(Data_Functor.map(((dictMonad.Bind1()).Apply0()).Functor0())(Let.create(v1.value0)(v1.value1))(v(v1.value2)))(v(v1.value3));
                    };
                    if (v1 instanceof FixPoint) {
                        return Data_Functor.map(((dictMonad.Bind1()).Apply0()).Functor0())(FixPoint.create(v1.value0)(v1.value1))(v(v1.value2));
                    };
                    if (v1 instanceof Expression) {
                        return Data_Functor.map(((dictMonad.Bind1()).Apply0()).Functor0())(Expression.create(v1.value0))(v(v1.value1));
                    };
                    if (v1 instanceof If) {
                        return Control_Apply.apply((dictMonad.Bind1()).Apply0())(Control_Apply.apply((dictMonad.Bind1()).Apply0())(Data_Functor.map(((dictMonad.Bind1()).Apply0()).Functor0())(If.create(v1.value0))(v(v1.value1)))(v(v1.value2)))(v(v1.value3));
                    };
                    return Control_Applicative.pure(dictMonad.Applicative0())(v1);
                };
            };
            var go$prime = function (expr) {
                return Control_Bind.bind(dictMonad.Bind1())(f(expr))(function (expr$prime) {
                    return Control_Bind.bind(dictMonad.Bind1())(filter(expr$prime))(function (cond) {
                        if (cond) {
                            return go(go$prime)(expr$prime);
                        };
                        return Control_Applicative.pure(dictMonad.Applicative0())(expr$prime);
                    });
                });
            };
            return go$prime;
        };
    };
};
var foldExpression = function (dictMonoid) {
    return function (filter) {
        return function (f) {
            var $382 = everywhereOnExpressionM(Control_Monad_Writer_Trans.monadWriterT(dictMonoid)(Data_Identity.monadIdentity))((function () {
                var $384 = Control_Applicative.pure(Control_Monad_Writer_Trans.applicativeWriterT(dictMonoid)(Data_Identity.applicativeIdentity));
                return function ($385) {
                    return $384(filter($385));
                };
            })())(function (expr) {
                return Data_Functor.voidLeft(Control_Monad_Writer_Trans.functorWriterT(Data_Identity.functorIdentity))(Control_Monad_Writer_Class.tell(Control_Monad_Writer_Trans.monadTellWriterT(dictMonoid)(Data_Identity.monadIdentity))(f(expr)))(expr);
            });
            return function ($383) {
                return Control_Monad_Writer.execWriter($382($383));
            };
        };
    };
};
var everywhereOnExpression = function (filter) {
    return function (mapper) {
        var $386 = Data_Newtype.unwrap(Data_Identity.newtypeIdentity);
        var $387 = everywhereOnExpressionM(Data_Identity.monadIdentity)(function ($389) {
            return Data_Identity.Identity(filter($389));
        })(function ($390) {
            return Data_Identity.Identity(mapper($390));
        });
        return function ($388) {
            return $386($387($388));
        };
    };
};
var mapExpression = everywhereOnExpression(Data_Function["const"](true));
var removeWrappers = (function () {
    var go = function ($copy_v) {
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v) {
            if (v instanceof Expression) {
                $copy_v = v.value1;
                return;
            };
            $tco_done = true;
            return v;
        };
        while (!$tco_done) {
            $tco_result = $tco_loop($copy_v);
        };
        return $tco_result;
    };
    return mapExpression(go);
})();
var printRawExpression = function (print) {
    return function (expression) {
        if (expression instanceof Variable) {
            return Data_Newtype.unwrap(newtypeVarName)(expression.value1);
        };
        if (expression instanceof FunctionCall && isFunctionCall(removeWrappers(expression.value2))) {
            return print(expression.value1) + (" (" + (print(expression.value2) + ")"));
        };
        if (expression instanceof FunctionCall) {
            return print(expression.value1) + (" " + print(expression.value2));
        };
        if (expression instanceof Lambda) {
            var v = unfoldLambda$prime(expression);
            return "\\" + (Data_String_Common.joinWith(" ")(Data_Array.fromFoldable(Data_List_Types.foldableList)(Data_Functor.map(Data_List_Types.functorList)(Data_Show.show(showVarName))(v.value0))) + (" -> " + print(v.value1)));
        };
        if (expression instanceof TypedHole) {
            return "_";
        };
        if (expression instanceof Let) {
            return printLet(true)(printRawExpression(print))(expression);
        };
        if (expression instanceof If) {
            return Data_String_Common.joinWith("\x0a")([ "if " + (print(expression.value1) + " then"), Lunarbox_Data_String.indent(4)(print(expression.value2)), "else", Lunarbox_Data_String.indent(4)(print(expression.value3)) ]);
        };
        if (expression instanceof FixPoint) {
            return print(new Lambda(expression.value0, expression.value1, expression.value2));
        };
        if (expression instanceof Native) {
            return "native";
        };
        if (expression instanceof Expression) {
            return "(" + (print(expression.value1) + ")");
        };
        throw new Error("Failed pattern match at Lunarbox.Data.Dataflow.Expression (line 229, column 39 - line 248, column 42): " + [ expression.constructor.name ]);
    };
};
var printExpressionAt = function (dictShow) {
    return function (dictEq) {
        return function (location) {
            return printRawExpression(function (expression) {
                var $299 = Data_Eq.eq(dictEq)(getLocation(expression))(location);
                if ($299) {
                    return printExpressionAt(dictShow)(dictEq)(location)(expression);
                };
                return "...";
            });
        };
    };
};
var printSource$prime = printRawExpression(function (e) {
    return printSource$prime(e);
});
var showExpression = function (dictShow) {
    return new Data_Show.Show(function (expr) {
        return "(" + (Data_Show.show(dictShow)(getLocation(expr)) + (": " + (printRawExpression(Data_Show.show(showExpression(dictShow)))(expr) + ")")));
    });
};
var sumarizeExpression = function (dictShow) {
    return function (dictEq) {
        return printRawExpression(Data_Function["const"]("..."));
    };
};
var printSource = function ($391) {
    return printSource$prime(removeWrappers($391));
};
var eqVarName = new Data_Eq.Eq(function (x) {
    return function (y) {
        return x === y;
    };
});
var ordVarName = new Data_Ord.Ord(function () {
    return eqVarName;
}, function (x) {
    return function (y) {
        return Data_Ord.compare(Data_Ord.ordString)(x)(y);
    };
});
var references = function (target) {
    var go = function (v) {
        if (v instanceof Variable && Data_Eq.eq(eqVarName)(target)(v.value1)) {
            return [ v.value0 ];
        };
        return [  ];
    };
    var filterExpr = function (v) {
        if (v instanceof Lambda && Data_Eq.eq(eqVarName)(v.value1)(target)) {
            return false;
        };
        if (v instanceof FixPoint && Data_Eq.eq(eqVarName)(v.value1)(target)) {
            return false;
        };
        if (v instanceof Let && Data_Eq.eq(eqVarName)(v.value1)(target)) {
            return false;
        };
        return true;
    };
    return foldExpression(Data_Monoid.monoidArray)(filterExpr)(go);
};
var isReferenced = function (target) {
    var $392 = Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraBoolean);
    var $393 = references(target);
    return function ($394) {
        return $392(Data_Array["null"]($393($394)));
    };
};
var eqNativeExpression = new Data_Eq.Eq(function (x) {
    return function (y) {
        return Data_Eq.eq(Lunarbox_Data_Dataflow_Scheme.eqScheme)(x.value0)(y.value0) && Data_Eq.eq(Lunarbox_Data_Dataflow_Runtime.eqRuntimeValue)(x.value1)(y.value1);
    };
});
var eqExpression = function (dictEq) {
    return new Data_Eq.Eq(function (x) {
        return function (y) {
            if (x instanceof Variable && y instanceof Variable) {
                return Data_Eq.eq(dictEq)(x.value0)(y.value0) && Data_Eq.eq(eqVarName)(x.value1)(y.value1);
            };
            if (x instanceof FunctionCall && y instanceof FunctionCall) {
                return Data_Eq.eq(dictEq)(x.value0)(y.value0) && Data_Eq.eq(eqExpression(dictEq))(x.value1)(y.value1) && Data_Eq.eq(eqExpression(dictEq))(x.value2)(y.value2);
            };
            if (x instanceof Lambda && y instanceof Lambda) {
                return Data_Eq.eq(dictEq)(x.value0)(y.value0) && Data_Eq.eq(eqVarName)(x.value1)(y.value1) && Data_Eq.eq(eqExpression(dictEq))(x.value2)(y.value2);
            };
            if (x instanceof Let && y instanceof Let) {
                return Data_Eq.eq(dictEq)(x.value0)(y.value0) && Data_Eq.eq(eqVarName)(x.value1)(y.value1) && Data_Eq.eq(eqExpression(dictEq))(x.value2)(y.value2) && Data_Eq.eq(eqExpression(dictEq))(x.value3)(y.value3);
            };
            if (x instanceof If && y instanceof If) {
                return Data_Eq.eq(dictEq)(x.value0)(y.value0) && Data_Eq.eq(eqExpression(dictEq))(x.value1)(y.value1) && Data_Eq.eq(eqExpression(dictEq))(x.value2)(y.value2) && Data_Eq.eq(eqExpression(dictEq))(x.value3)(y.value3);
            };
            if (x instanceof FixPoint && y instanceof FixPoint) {
                return Data_Eq.eq(dictEq)(x.value0)(y.value0) && Data_Eq.eq(eqVarName)(x.value1)(y.value1) && Data_Eq.eq(eqExpression(dictEq))(x.value2)(y.value2);
            };
            if (x instanceof Expression && y instanceof Expression) {
                return Data_Eq.eq(dictEq)(x.value0)(y.value0) && Data_Eq.eq(eqExpression(dictEq))(x.value1)(y.value1);
            };
            if (x instanceof Native && y instanceof Native) {
                return Data_Eq.eq(dictEq)(x.value0)(y.value0) && Data_Eq.eq(eqNativeExpression)(x.value1)(y.value1);
            };
            if (x instanceof TypedHole && y instanceof TypedHole) {
                return Data_Eq.eq(dictEq)(x.value0)(y.value0);
            };
            return false;
        };
    });
};
module.exports = {
    NativeExpression: NativeExpression,
    Variable: Variable,
    FunctionCall: FunctionCall,
    Lambda: Lambda,
    Let: Let,
    If: If,
    FixPoint: FixPoint,
    Expression: Expression,
    Native: Native,
    TypedHole: TypedHole,
    VarName: VarName,
    functionDeclaration: functionDeclaration,
    getLocation: getLocation,
    toMap: toMap,
    locations: locations,
    lookup: lookup,
    printExpressionAt: printExpressionAt,
    printRawExpression: printRawExpression,
    printSource: printSource,
    sumarizeExpression: sumarizeExpression,
    inputs: inputs,
    removeWrappers: removeWrappers,
    everywhereOnExpressionM: everywhereOnExpressionM,
    everywhereOnExpression: everywhereOnExpression,
    foldExpression: foldExpression,
    mapExpression: mapExpression,
    references: references,
    isReferenced: isReferenced,
    unfoldLambda: unfoldLambda,
    eqVarName: eqVarName,
    ordVarName: ordVarName,
    showVarName: showVarName,
    newtypeVarName: newtypeVarName,
    eqNativeExpression: eqNativeExpression,
    showNativeExpression: showNativeExpression,
    eqExpression: eqExpression,
    functorExpression: functorExpression,
    showExpression: showExpression
};
